import React from "react";
import {
    GridRow,
    GridColumn,
    ListTable,
    Grid,
    SearchBox,
    Stack,
    ClearFiltersButton,
    ContentSection,
    ButtonRenderProps,
    ButtonProps
} from "sprint-common-web";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { CreateIntegratorButton } from "./buttons/CreateIntegratorButton";
import { createIntegratorListingColumns } from "./createIntegratorListingColumns";
import { useIntegratorListing } from "./useIntegratorListing";
import { useIntegratorListingFilters } from "./useIntegratorListingFilters";

export const IntegratorListing: React.FC = () => {
    const { filters, setSort, setPage, setPageSize, setName, clearFilters } = useIntegratorListingFilters();
    const { items, totalItems, isLoading } = useIntegratorListing(filters);

    const columns = createIntegratorListingColumns();

    const createIntegratorButtonProps: ButtonRenderProps<ButtonProps> = {
        render: CreateIntegratorButton
    };

    return (
        <>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <ContentSection header={"Integrators"} buttons={[createIntegratorButtonProps]}>
                <Grid>
                    <GridRow>
                        <GridColumn sm={3}>
                            <SearchBox placeholder="Name" onChange={setName} value={filters.name} />
                        </GridColumn>
                        <GridColumn sm={9}>
                            <Stack horizontalAlign="end">
                                <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                            </Stack>
                        </GridColumn>
                    </GridRow>
                    <GridRow>
                        <GridColumn sm={12}>
                            <ListTable
                                columns={columns}
                                items={items}
                                pagination={{
                                    page: filters.page,
                                    pageSize: filters.pageSize,
                                    totalItems,
                                    onPageChange: setPage,
                                    onPageSizeChange: setPageSize
                                }}
                                sort={{ by: filters.sortBy, order: filters.sortOrder }}
                                onSortChange={setSort}
                                isLoading={isLoading}
                            />
                        </GridColumn>
                    </GridRow>
                </Grid>
            </ContentSection>
        </>
    );
};
